import styled from 'styled-components';
import { colourPalette } from 'styles/styles';
export const CreditsModalTopupFormStyle = {
  Container: styled.div`
    padding: 24px;
    border: 1px solid ${colourPalette.neutral300};
    border-radius: 8px;
    margin: 0;
  `,
  Title: styled.p`
    margin: 0;
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: 500;
    line-height: 100%;
    color: ${colourPalette.neutral900};
  `,
  ButtonsBox: styled.div`
    margin-top: 32px;
  `,
  FormButtonsBox: styled.div`
    margin-top: 8px;
  `,
};
